/**
 * 社員台帳ページ用のスクリプト
 */
 var user_treemultiselect = null;

if (is_route('user.index')) {
    // コンテンツ読み込み後
    $(document).on('amc:onload', function() {
        user_event_set();
        user_setting_event_set();
        // user_batch_transfer_event_set();
    });
}
/**
 * ページ読み込み時のイベント設定
 */
window.user_event_set = function() {

    // ボタンクリック時のバブリングを禁止
    $(document).on('click', '.user_license_file_link', function (e) {
        // バブリングを禁止
        e.stopPropagation();
    });

    /*---- 詳細表示時 ----*/

    // 詳細表示時
    $(document).on('click', '[data-detail-modal]', function () {
        _modal.create(this, 'detail-modal', ['id']);
    });

    // 前へ・次へ
    $(document).on('click', '.modal-user-prev, .modal-user-next', function () {
        let datas = $('#search-form').serializeArray();
        datas.push({'name': 'id', 'value': $(this).data('id')});
        let action = $(this).data('action');
        let modalId = $(this).data('modal_id');
        _modal.update(modalId, action, datas);
    });

    /*---- 設定表示時 ----*/

    // 設定表示時
    $(document).on('click', '[data-setting-modal]', function () {
        _modal.create(this, 'setting-modal', ['id', 'type']);
    });

    /*---- 所属一括変更表示時 ----*/

    // 所属一括変更表示時
    $(document).on('click', '#search-form-action_batch_transfer', function () {
        _modal.create(this, 'batch-transfer-modal', ['id', 'type'], false, function() {
            user_treemultiselect = initialize_treemultiselect();
            user_batch_transfer_event_set();
        });
    });

    /*---- 履歴表示時 ----*/

    // 履歴表示時
    $(document).on('click', '[data-history-modal]', function () {
        _modal.create(this, 'history-modal', ['id', 'page']);
        return false;
    });

    /*---- 設定保存時 ----*/

    // 設定保存時
    $(document).on('click', '[data-save-modal]', function () {
        // 確認フラグがtrueで、メールアドレスが削除されている場合
        if ($(this).data('confirm-flag') && !$('#user-setting-modal-email').val()) {
            _modal.create(this, 'save-confirm-modal', ['id'], false, null, 'save-confirm-action');
            return;
        }
        _modal.submit(this, 'save-modal', function(results) {
            $('[data-detail-modal=user-detail-modal][data-id=' + results.user.id + ']').trigger('click');
        }, function() {
            user_set_steper_error();
        });
    });
    // 確認モーダルの保存ボタン押下時
    $(document).on('click', '#user-save-confirm-modal-submit-btn', function () {
        $('[data-save-modal]').data('confirm-flag', false);
        _modal.hide('#user-save-confirm-modal');
        $('[data-save-modal]').trigger('click');
    });

    /*---- 一括削除チェックボックス操作時 ----*/

    // 一括のチェックボックスクリック時
    $(document).on('click', '#user-all-delete', function () {
        $(".user-delete").prop('checked', $(this).prop('checked'));
    });
    // 一覧のチェックボックスクリック時
    $(document).on('click', '.user-delete', function (e) {
        // バブリングを禁止
        e.stopPropagation();
    });
    // 一括・一覧のチェックボックス変更時
    $(document).on('change', '#user-all-delete, .user-delete', function () {
        // 一覧のチェック状態を判定し削除ボタンを有効化
        $('#user-multi-delete-button').prop('disabled', ($('.user-delete:checked').length == 0));
    });

    /*---- 削除確認時 ----*/

    // 一括削除確認時
    $(document).on('click', '[data-confirm-modal]', function () {
        var ids = ($(this).data('id') == null ? [] : [$(this).data('id')]);
        if ($(this).data('id') == null) {
            $('.user-delete[name="ids[]"]:checked').map(function() {
                ids.push($(this).val());
            });
        }
        if (ids.length > 0) {
            _modal.create_with_data(this, 'confirm-modal', {'ids': ids});
        }
    });

    /*---- 削除処理 ----*/

    // 削除実行時
    $(document).on('click', '[data-delete-modal]', function () {
        _modal.submit(this, 'delete-modal', function(results) {
            _modal.hide('#user-detail-modal');
        });
    });

    // /*---- CSVダウンロード時 ----*/

    // // CSVダウンロード時
    // $(document).on('click', '#search-form-action_download', function () {
    //     // アクションの取得
    //     let action = extend_url_query($(this).data('action'));
    //     // 検索フォームを配列化
    //     let datas = $('#search-form').serializeArray();
    //     // ポスト送信を実行
    //     post(action, datas);
    // });

    /*---- CSVアップロード表示時 ----*/

    // CSVアップロード表示時
    $(document).on('click', '#search-form-action_upload', function () {
        // 初期化処理
        $('#user-csv-setting-modal-csv-submit-message').addClass('display-none');
        $('#user-csv-setting-modal-csv-submit-message').empty();
        $('#user-csv-setting-modal-csv-error').addClass('display-none');
        $('#user-csv-setting-modal-csv-error').empty();
        $('#user-csv-setting-modal-csv').val('');
    });

    /*---- CSVアップロード確認時 ----*/

    // CSVアップロード確認時
    $(document).on('change', '#user-csv-setting-modal-csv', function () {
        let modalId = '#user-csv-setting-modal';
        let formId = '#user-csv-setting-modal-form';
        let action = $(formId).data('confirm-action');
        let datas = new FormData($(formId).get(0));
        $(modalId + '-csv-error').addClass('display-none');
        $(modalId + '-csv-error').empty();
        $(modalId + '-csv-submit-message').addClass('display-none');
        $(modalId + '-csv-submit-message').empty();
        $("[data-csv-save-modal]").prop("disabled", true);
        // 送信
        _ajax.file(action, datas, function (results) {
            $(modalId + '-csv-submit-message').removeClass('display-none');
            $(modalId + '-csv-submit-message').text(results.messages[0]);
            $("[data-csv-save-modal]").prop("disabled", false);
        }, function(xhr, status, errorThrown){
            $('#user-csv-setting-modal-csv').val('');
            // フォームにエラーメッセージを配置
            $.each(xhr.responseJSON.errors, function(name, message) {
                $(modalId + '-csv-error').removeClass('display-none');
                $(modalId + '-csv-error').append($('<li></li>').text(message));
            });
            _error.omitted(xhr, status, errorThrown, false);
        });
    });

    /*---- CSVアップロード時 ----*/

    // 設定表示時
    $(document).on('click', '[data-csv-save-modal]', function () {
        let modalId = '#user-csv-setting-modal';
        let formId = '#user-csv-setting-modal-form';
        let action = $(formId).attr('action');
        let datas = new FormData($(formId).get(0));
        // 送信前にエラーをリセット
        _error.reset()
        // 送信
        _ajax.file(action, datas, function (results) {
            // 完了メッセージをセットする
            _complete.set(results);
            // モーダルを閉じる
            _modal.hide(modalId);
            // コンテンツの読込
            load_contents();
        }, function(xhr, status, errorThrown){
            // エラーをセットする
            _error.omitted(xhr, status, errorThrown);
        });
    });

    $(document).on('click', '.transfered .btn-group', function (event) {
        event.preventDefault();
    });

}
/**
 * 設定モーダル表示時のイベント設定
 * @uses ダッシュボードからモーダル表示する際にも呼び出される
 */
window.user_setting_event_set = function() {

    /*---- 営業所の選択時 ----*/

    // 営業所の選択時
    $(document).on('change', '#user-setting-modal-section_id', function() {
        if($(this).val() != null && $(this).val().length > 0){
            updateOoccupationDetailForms($(this));
            // updateBelongDetailForms($(this));
        }
    });

    // 職種設定画面表示
    function updateOoccupationDetailForms(elm)
    {
        let action = $('#occupation_detail_forms').data('action');
        // 送信
        _ajax.post(action, [
            {'name': 'id', 'value': $('#user-setting-modal-id').val()},
            {'name': 'section_id', 'value': $(elm).val()},
        ], function (results) {
            $('#occupation_detail_forms').html(results);
            $('#driver-license').toggleClass('display-none', true);
            $('#operation-supervision-license').toggleClass('display-none', true);
            $('#operation-manager-license').toggleClass('display-none', true);
            initialize('datepicker');
            $('.occupation_detail').toggleClass('display-none', true);
        }, function(xhr, status, errorThrown) {
            _error.omitted(xhr, status, errorThrown);
        }, 'html');
    }

    // 所属設定画面表示
    function updateBelongDetailForms(elm)
    {
        let action = $('#belong_detail_forms').data('action');
        // 送信
        _ajax.post(action, [
            {'name': 'id', 'value': $('#user-setting-modal-id').val()},
            {'name': 'section_id', 'value': $(elm).val()},
        ], function (results) {
            $('#belong_detail_forms').html(results);
            initialize('datepicker');
        }, function(xhr, status, errorThrown) {
            _error.omitted(xhr, status, errorThrown);
        }, 'html');
    }

    /*---- 職種の選択時 ----*/

    // 職種の選択時
    $(document).on('change', '.occupation-check input[name="occupation_ids[]"]', function() {
        let occupationTypes = [];
        $(this).parents('.occupation-check').find('input[name="occupation_ids[]"]').each(function() {
            if ($(this).prop('checked') && $(this).data('occupation-type') > 0) {
                occupationTypes.push($(this).data('occupation-type'));
            }
        });
        $('.area_driver').toggleClass('display-none', !(occupationTypes.find(v => v == 9) > 0));
        $('.area_operation').toggleClass('display-none', !(occupationTypes.find(v => (v == 3 || v == 4)) > 0));
        $('.area_maintenance').toggleClass('display-none', !(occupationTypes.find(v => v == 5 || v == 6) > 0));
        $('.area_supervision').toggleClass('display-none', !(occupationTypes.find(v => v == 2) > 0));
        $('.area_safety').toggleClass('display-none', !(occupationTypes.find(v => v == 12) > 0)).promise().done(function(){
            // [管理車両を含む]非表示のため処理コメント
            // let vehicleManager = $('input[name="occupation_ids[]"][data-occupation-type="13"]:checked');
            // if (vehicleManager.length > 0) {
            //     $('.area_safety input[name="vehicle_managed_too"]').prop('checked', true);
            // } else {
            //     $('.area_safety input[name="vehicle_managed_too"]').prop('checked', false);
            // }
        });
    });

    // 職種「安全運転管理者」、「管理車両を含む」＝「車両管理者ON」の制御
    $(document).on('click', '.area_safety input[name="vehicle_managed_too"]', function(){
        let vehicleManager = $('#occupation-part input[name="occupation_ids[]"][data-occupation-type="13"]');
        if ($(this).prop('checked')) {
            vehicleManager.prop('checked', true);
        } else {
            vehicleManager.prop('checked', false);
        }
    })


    // /*---- 雇用形態と入社日の変更時 ----*/

    // $(document).on('change', '#user-setting-modal-employment_id, #user-setting-modal-employ_date', function() {
    //     let employmentId = $('#user-setting-modal-employment_id').val();
    //     if (employmentId > 0) {
    //         let action = $('#paid-holiday-setting').data('action');
    //         let data = $('#user-setting-modal-form').serialize();
    //         _ajax.post(action, data, function (results) {
    //             $('#paid-holiday-setting').html(results);
    //         }, function(xhr, status, errorThrown){
    //             _error.omitted(xhr, status, errorThrown);
    //         }, 'html');
    //     }
    // });

    // /*---- 雇入年月日と最低有給日数の変更時 ----*/

    // $(document).on('change', '#user-setting-modal-employ_date, #user-setting-modal-holiday_min', function() {
    //     if ($('#user-setting-modal-holiday_rest').val().length > 0 || $('#user-setting-modal-employ_date').val().length == 0 || $('#user-setting-modal-holiday_min').val().length == 0) {
    //         return;
    //     }
    //     let holidayRest = 0;
    //     let employDate = moment($('#user-setting-modal-employ_date').val(), 'YYYY-MM-DD');
    //     let holidayMin = $('#user-setting-modal-holiday_min').val();
    //     let now = moment();
    //     if (now.isAfter(employDate)) {
    //         let years = Math.ceil(now.diff(employDate, 'years', true));
    //         holidayRest = holidayMin * years;
    //     }
    //     $('#user-setting-modal-holiday_rest').val(holidayRest + $('#user-setting-modal-holiday_rest').data('suffix'));
    //     $('input[name=holiday_rest]').val(holidayRest).trigger('change');
    // });

    /*---- ステップボタンクリック時（新規登録時） ----*/

    // 前へ
    $(document).on('click', '[data-prev-step]', function () {
        // Partセレクターの指定
        let currentPartSubmit = $(this).parents('.modal-footer');
        let prevPart = $(this).data('prev-step');
        let prevPartTrigger = create_id(prevPart + '-trigger');
        let prevPartSubmit = create_id(prevPart + '-submit');
        $(currentPartSubmit).addClass('display-none');
        $(prevPartSubmit).removeClass('display-none');
        bs_step_trigger(prevPartTrigger);
    });

    // 次へ
    $(document).on('click', '[data-next-step]', function () {
        // Partセレクターの指定
        let currentPartSubmit = $(this).parents('.modal-footer');
        let nextPart = $(this).data('next-step');
        let nextPartTrigger = create_id(nextPart + '-trigger');
        let nextPartSubmit = create_id(nextPart + '-submit');
        // ModalとPartセレクターの指定
        let modalId = '#user-setting-modal';
        let formId = '#user-setting-modal-form';
        let action = $(formId).data('confirm-action');
        // 確認対象のパートをパラメータにセット
        $('#user-setting-modal-confirm_step').val($(this).data('confirm-step'));
        // 送信前にエラーをリセット
        _error.reset()
        user_set_steper_error(false);
        // 確認用のpost送信
        _ajax.confirm_submit(formId, action, function (results) {
            $(currentPartSubmit).addClass('display-none');
            $(nextPartSubmit).removeClass('display-none');
            bs_step_trigger(nextPartTrigger);
        }, function(xhr, status, errorThrown){
            // エラーをセットする
            _error.set(modalId, xhr, status, errorThrown, false);
            // ステップエラーを表示
            user_set_steper_error();
        });
    });

    /*---- 資格情報の追加ボタンを押下(資格入力項目を追加する) ----*/

    $(document).on('click', '#license-part button[name="add_license"]', function(){
        var count = $('#license-part .card').length;
        var card = $('#license-part .card:first').clone();

        // 削除項目あれば消す
        card.find('input[name="license_delete[]"]').remove();
        card.find('#label_license_delete').remove();

        // 追加要素の初期化
        card.find('input').each(function() {
            $(this).val('');
            var id = $(this).attr('id');
            var newId = id.replace(/_0/g , '_' + count);
            var label = card.find('label[for="' + id + '"]');
            var error = card.find('#' + id + '-errors');

            // ID書き換え
            $(this).attr('id', newId);
            label.attr('for', newId);

            // error初期化
            if (error.length > 0) {
                error.attr('id', newId + '-errors');
                error.find('span').html('');
            }
        });

        // 最後に追加
        card.insertAfter('#license-part .card:last');

        initialize();

        // 50件になったら追加ボタン殺す
        if (count + 1 >= 50) {
            $(this).prop('disabled', true);
        }
    });

    /*---- 会社選択時 ----*/

    $(document).on('change', '#user-setting-modal-company_id', function() {
        // 社員ID(code)自動生成ボタンON/OFF
        if ($('#generate-user-code').length > 0) {
            if ($(this).val().length > 0) {
                $('#generate-user-code').prop('disabled', false);
            } else {
                $('#generate-user-code').prop('disabled', true);
            }
        }
        if($(this).val() != null && $(this).val().length > 0){
            updateInformationDetailForms($(this));
        }
    });

    function updateInformationDetailForms(elm)
    {
        let action = $('#information_detail_forms').data('action');
        // 送信
        _ajax.post(action, [
            {'name': 'id', 'value': $('#user-setting-modal-id').val()},
            {'name': 'company_id', 'value': $(elm).val()},
        ], function (results) {
            $('#information_detail_forms').html(results);
        }, function(xhr, status, errorThrown) {
            _error.omitted(xhr, status, errorThrown);
        }, 'html');
    }

    /*---- 自動生成実行時 ----*/

    $(document).on('click', '#generate-user-code', function () {
        let action = $(this).data('action');
        // codeセット
        _ajax.post(action, [
            {'name': 'company_id', 'value': $('#user-setting-modal-company_id').val()},
        ], function (results) {
            $('#user-setting-modal-user_code').val(results.generated);
        }, function(xhr, status, errorThrown) {
            _error.omitted(xhr, status, errorThrown);
        });
    });

    /*---- お知らせ個別設定変更時 ----*/

    // switch
    $(document).off('change', '.information_individual_flag');
    $(document).on('change', '.information_individual_flag', function() {
        if($(this).val() == '1'){
            $('#user-setting-modal-information-area').removeClass('display-none');
        }else{
            $('#user-setting-modal-information-area').addClass('display-none');
        }
    });

    /*---- お知らせ個別設定変更時 ----*/

    function setDisplayOfValueInput(elm) {
        let input = $('input[id=user-setting-modal-' + $(elm).data('target') + ']');
        if ($(input).attr('type') != 'hidden') {
            $(input).toggleClass('display-none', ($(elm).val() != '1'));
            if ($(input).val() == '') {
                $(input).val($(input).data('default'));
            }
            let suffix = $('#user-setting-modal-' + $(elm).data('target') + '_suffix');
            $(suffix).toggleClass('display-none', ($(elm).val() != '1'));
        }
    }
    // switch
    $(document).off('change', '.information_item_flag');
    $(document).on('change', '.information_item_flag', function() {
        setDisplayOfValueInput(this);
    });
    $('.information_item_flag:checked').each(function () {
        setDisplayOfValueInput(this);
    });

}

/**
 * ステッパーへのエラー表示処理
 * @param {*} showError
 */
window.user_set_steper_error = function (showError = true) {
    if (showError) {
        $('#base-part-trigger').toggleClass('error', ($('#base-part').find('.invalid-feedback:not(.copy)').length > 0));
        // $('#belong-part-trigger').toggleClass('error', ($('#belong-part').find('.invalid-feedback:not(.copy)').length > 0));
        $('#occupation-part-trigger').toggleClass('error', ($('#occupation-part').find('.invalid-feedback:not(.copy)').length > 0));
        $('#license-part-trigger').toggleClass('error', ($('#license-part').find('.invalid-feedback:not(.copy)').length > 0));
        // $('#insurance-part-trigger').toggleClass('error', ($('#insurance-part').find('.invalid-feedback:not(.copy)').length > 0));
        $('#information-part-trigger').toggleClass('error', ($('#information-part').find('.invalid-feedback:not(.copy)').length > 0));
    } else {
        $('#base-part-trigger').removeClass('error');
        // $('#belong-part-trigger').removeClass('error');
        $('#occupation-part-trigger').removeClass('error');
        $('#license-part-trigger').removeClass('error');
        // $('#insurance-part-trigger').removeClass('error');
        $('#information-part-trigger').removeClass('error');
    }
}

/**
 * 所属一括変更モーダル表示時のイベント設定
 */
window.user_batch_transfer_event_set = function () {

    /*---- 初期処理 ----*/

    let holdingId = $('#user-batch-transfer-modal-holding_id').val();
    if (holdingId.length > 0) {
        setTreeMultiSelect('#user-batch-transfer-modal-holding_id', 'select.users-select', {'type': 'transfer', 'holding_id': holdingId});
    }

    /*---- グループ変更時 ----*/

    $(document).on('change', '#user-batch-transfer-modal select.holding-select', function () {
        let holdingId = $(this).val();
        let select = $(this).parents('form').find('select.users-select');
        clearTreeMultiSelect(select);
        if (holdingId.length > 0) {
            setTreeMultiSelect(this, 'select.users-select', {'type': 'transfer', 'holding_id': holdingId});
        }
    });

    /*---- 設定保存時 ----*/

    // 設定保存時
    $(document).off('click', '[data-batch-transfer-save-modal]').on('click', '[data-batch-transfer-save-modal]', function () {
        _modal.submit(this, 'batch-transfer-save-modal', function(results) {
            _modal.hide('#user-batch-transfer-modal');
        });
    });

    // セレクトの値をセットする
    function setTreeMultiSelect(elm, find, datas = {}, callback = null) {
        let select = $(elm).parents('form').find(find);
        if (select.length > 0) {
            let action = $(select).data('action');
            _ajax.post(action, datas, function (results) {
                clearTreeMultiSelect(select);
                $.each(results.options, function(index, option) {
                    if(option.id == ''){ return true; }
                    $(select).append($('<option></option>', {
                        'value': option.id,
                        'data-section': option.company_name + '|' + option.section_name
                    }).text(option.text));
                })
                user_treemultiselect[0][0].reload();
                $('div.tree-multiselect .search').attr('placeholder', $(select).data('search'));
                if (callback != null) {
                    callback(elm);
                }
            }, function(xhr, status, errorThrown){
                _error.omitted(xhr, status, errorThrown);
            });
        }
    }

    // セレクトの値をクリアする
    function clearTreeMultiSelect(select) {
        $(select).empty();
        user_treemultiselect[0][0].remove();
        user_treemultiselect[0][0].reload();
        $('div.tree-multiselect .search').attr('placeholder', $(select).data('search'));
    }
}
